import SubcategoryPage from '@/components/template/SubcategoryPage';

const EdmundTable = () => {
  const products = [
    {
      title: "Edmund Table Mini",
      imageSrc: "https://images.unsplash.com/photo-1604061986761-d9d0cc41b0d1?auto=format&fit=crop&q=80",
      url: "/proizvodi/edmund-table-mini"
    },
    {
      title: "Edmund Table Standard",
      imageSrc: "https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80",
      url: "/proizvodi/edmund-table-standard"
    },
    {
      title: "Edmund Table Premium",
      imageSrc: "https://images.unsplash.com/photo-1589584649628-b597067e07a3?auto=format&fit=crop&q=80",
      url: "/proizvodi/edmund-table-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Edmund Table"
      description="Dizajnerske Edmund mize, ki združujejo eleganco in funkcionalnost za sodoben življenjski slog."
      heroImage="https://images.unsplash.com/photo-1604061986761-d9d0cc41b0d1?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default EdmundTable;